<template>
	<div class="top_bar border_b">
		<div class="view">
			<img class="logo" src="../../../assets/logo_theme.png" alt="">
			<a class="old_link text_theme border_theme" href="http://oldwww.uflyvision.com.cn" target="_blank">返回旧版本</a>
			<ul class="navigations">
				<li><a href="javascript: void(0);" :class="{'text_theme': active_index == 0,'text_underline': active_index == 0}" data-url="/index/home" @click="handleLinkClick">首页</a></li>
				<li><a href="javascript: void(0);" :class="{'text_theme': active_index == 1,'text_underline': active_index == 1}" data-url="/index/download" @click="handleLinkClick">产品下载</a></li>
				<li><a href="javascript: void(0);" :class="{'text_theme': active_index == 2,'text_underline': active_index == 2}" data-url="/index/guide" @click="handleLinkClick">使用指导</a></li>
				<li><a href="javascript: void(0);" :class="{'text_theme': active_index == 3,'text_underline': active_index == 3}" data-url="/index/science_park" @click="handleLinkClick">科普园地</a></li>
				<li><a href="javascript: void(0);" :class="{'text_theme': active_index == 4,'text_underline': active_index == 4}" data-url="/index/recovery_case" @click="handleLinkClick">康复案例</a></li>
				<li><a href="javascript: void(0);" data-url="/course" @click="handleLinkClick">科飞网课</a></li>
				<li><a href="javascript: void(0);" :class="{'text_theme': active_index == 6,'text_underline': active_index == 6}" data-url="/index/about_us" @click="handleLinkClick">关于我们</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.updateIndexByRoute();
		},
		data() {
			return {
				active_index: -1
			}
		},
		methods: {
			/********************** @Events ****************************/
			// 点击选项卡
			handleLinkClick(e) {
				let path = e.target.dataset.url;
				let current_path = this.$route.path;
				path != current_path && this.$router.push({ path });
			},
			
			/********************** @Function ****************************/
			// 根据路由改变高亮索引
			updateIndexByRoute() {
				let path = this.$route.path;
				switch(path) {
					case '/index/home':
						this.active_index = 0;
						break;
					case '/index/download':
						this.active_index = 1;
						break;
					case '/index/guide':
						this.active_index = 2;
						break;
					case '/index/science_park':
						this.active_index = 3;
						break;
					case '/index/recovery_case':
						this.active_index = 4;
						break;
					case '/index/about_us':
						this.active_index = 6;
						break;
					default:
						this.active_index = -1;
						break;
				}
			}
		},
		watch: {
			$route(){
				this.updateIndexByRoute();
			}
		}
	}
</script>

<style scoped>
	.top_bar{ position: fixed;z-index: 99;width: 100%;min-width: 1200px;height: 80px;top: 0;left: 0;background: #fff; }
	.top_bar .view{ width: 1200px;height: 80px;margin: 0 auto; }
	.top_bar .logo{ float: left;margin-top: 15px; }
	.top_bar .navigations{ float: right;margin-top: 20px; }
	.top_bar .navigations li{ display: inline-block;margin: 0 25px 0;font-size: 18px;line-height: 42px;vertical-align: top; }
	.top_bar .navigations a:hover{ color: #2b53c6; }
	.top_bar .old_link{ display: block;float: right;margin-top: 27px;padding: 0 12px;border-style: solid;border-width: 1px;border-radius: 14px;font-size: 16px;line-height: 26px; }
</style>
